//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      swiper: null,
      timer: null,
    };
  },
  props: {
    width: {
      type: [Number, String],
      default: "100%",
    },
    height: {
      type: [Number, String],
      default: 175 / 40 + "rem",
    },
    pagination: {
      type: Boolean,
      default: true,
    },
    noArrow: {
      type: Boolean,
      default: false,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Number,
      default: 2000,
    },
    swipers: {
      type: Object,
      default() {
        return {
          list: [
            {
              config: {
                row: 2,
                column: [
                  { top: "5000+家", down: "地产客户", href: "" },
                  { top: "90+家", down: "全国100强客户", href: "" },
                  { top: "全国60%新房", down: "销售管理平台", href: "" },
                ],
              },
            },
            {
              config: {
                row: 2,
                column: [
                  { top: "1000+家", down: "傻逼客户", href: "" },
                  { top: "10+家", down: "全国最差客户", href: "" },
                  { top: "全国60%旧房", down: "销售管理平台", href: "" },
                ],
              },
            },
          ],
        };
      },
    },
    complete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    swiperConfig() {
      let width = null,
        height = null;
      if (typeof this.width === "number") {
        width = this.width + "px";
      } else {
        width = this.width;
      }
      if (typeof this.height === "number") {
        height = this.height + "px";
      } else {
        height = this.height;
      }
      return {
        width: width,
        height: height,
      };
    },
    swiperDomConfig() {
      let config = {
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        slidesPerView: 1,
        paginationClickable: true,
        spaceBetween: 30,
        loop: true,
        centeredSlides: true,
        onTap: function (swiper) {
          let url = swiper.clickedSlide.dataset["url"];
          if (url) {
            window.open(url, "_self", true);
          }
        },
      };
      if (!this.pagination) {
        delete config["pagination"];
      }
      if (this.noArrow) {
        delete config["nextButton"];
        delete config["prevButton"];
      }
      if (!this.paginationClickable) {
        config.paginationClickable = false;
      }
      if (!this.loop) {
        config["loop"] = false;
      }
      if (typeof this.autoplay === "number") {
        config["autoplay"] = this.autoplay;
        config["autoplayDisableOnInteraction"] = false;
      }

      return config;
    },
  },
  watch: {
    complete() {
      this.initSwiper();
    },
  },
  mounted() {},
  methods: {
    initSwiper() {
      const self = this;
      const config = Object.create(self.swiperDomConfig);
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        if ("Swiper" in window) {
          clearInterval(this.timer);
          this.swiper = new Swiper(".swiper-container", config);
        }
      }, 100);
    },
  },
};



// WEBPACK FOOTER //
// ./src/vue-components/swiper/swiper.vue